import "./PowderTestingKnowledgeCentre.module.css";
import Header from "@/reusable_sections/Header";
import PowderKnowledge from "./sections/PowderKnowledge";
import FormatsGrid from "./sections/FormatsGrid";
import PowderSolutions from "./sections/PowderSolutions";
import Footer from "@/reusable_sections/Footer";
export default function PowderTestingKnowledgeCentrePage() {
  return <div>
      <Header />
      <PowderKnowledge />
      <FormatsGrid />
      <PowderSolutions />
      <Footer />
    </div>;
}